// @ts-ignore
import { getInstance } from "@/auth/auth0";
// @ts-ignore
import useJwt from "@/auth/jwt/useJwt";
// @ts-ignore
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
// @ts-ignore
import { encrypt } from "@/utils/crypto";
import { inject, provide } from "@vue/composition-api";
import io, { Socket } from "socket.io-client";

import Vue from "vue";
import VueSocketIOExt from "vue-socket.io-extended";
import { createToastInterface } from "vue-toastification";
import { ToastID } from "vue-toastification/dist/types/src/types";

// @ts-ignore
const socket: Socket = io(process.env.VUE_APP_FRONTEND_MS_WEBSOCKET_ENDPOINT, {
    transports: ["websocket", "polling"],
    cors: ["*"],
    autoConnect: false, // We connect after successfull login.
    reconnectionDelay: 5000,
    reconnectionDelayMax: 30000,
} as any);

socket.on("connect", () => {
    axios.defaults.headers.common["x-websocket-id"] = socket.id;
});

socket.on("disconnect", () => {
    const instance = getInstance();

    if (instance.loading) {
        const stop = instance.$watch("loading", (isLoading: boolean) => {
            if (!isLoading) {
                setWebsocketToken()
                    .then(() => {
                        socket.connect();
                    })
                    .finally(() => {
                        stop();
                    });
            }
        });
    } else {
        setWebsocketToken().then(() => socket.connect());
    }
});

// Events: https://socket.io/docs/v4/client-api/#event-error
let toastId: ToastID;
const toast = createToastInterface(
    {
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
        icon: false,
        timeout: false,
        transition: "Vue-Toastification__fade",
    },
    Vue
);

socket.io.on("reconnect_attempt", (attempt) => {
    if (attempt === 3) {
        toastId = toast({
            component: ToastificationContent,
            props: {
                title: i18n.t("websockets.system-message"),
                text: i18n.t("websockets.lost-connection"),
                icon: "exclamation-triangle",
                variant: "warning",
            },
        });
    }
});

socket.io.on("reconnect", () => {
    if (typeof toastId === "undefined") {
        return;
    }

    toast.dismiss(toastId); // Close the connection error toast.

    toast(
        {
            component: ToastificationContent,
            props: {
                title: i18n.t("websockets.system-message"),
                text: i18n.t("websockets.reconnected"),
                icon: "check",
                variant: "success",
            },
        },
        {
            timeout: 3000,
        }
    );

    // @TODO refetch chats and active chat data.
});

Vue.use(VueSocketIOExt, socket);

async function setWebsocketToken(): Promise<string> {
    const instance = getInstance();

    const accessToken = (await instance.auth0Client.getTokenSilently({ detailedResponse: true }))?.id_token;

    socket.io.opts.query = {
        accessToken,
    };

    return accessToken;
}

/*
 Composition API support
 */
// @ts-ignore
const send = async ({ type, payload, rooms }: { type: string; payload: any; rooms: string[] }) => {
    //if (this.initialized) {
    if (!rooms) {
        rooms = [];
    }

    await setWebsocketToken();

    payload.senderId = socket.id;
    const [event, iv] = encrypt({
        type,
        payload,
    });

    socket.emit("emitClientEvent", {
        event,
        iv,
        rooms,
    });

    //} else {
    //                this.emittedEventsBeforeInit.push({ type, payload, rooms });
    //            }
};

const websocketsSymbol = Symbol();

export function provideWebsockets() {
    const websockets: Socket = socket;

    provide(websocketsSymbol, websockets);
}

export function useWebsockets() {
    const websockets = inject(websocketsSymbol);
    if (!websockets) {
        throw new Error(
            "useWebsockets can only be used inside setup function. If you're using useWebsockets in a function, check the scope."
        );
    }

    return {
        websockets,
        sendWebsocketsMessage: send,
    };
}
